import { render, staticRenderFns } from "./ShowcaseProductPicker.vue?vue&type=template&id=fb48657c&scoped=true"
import script from "./ShowcaseProductPicker.vue?vue&type=script&lang=js"
export * from "./ShowcaseProductPicker.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseProductPicker.vue?vue&type=style&index=0&id=fb48657c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb48657c",
  null
  
)

export default component.exports